import { cn } from '@civilgrid/ui/utils';
import { useSnapshot } from 'valtio';
import { ObjCoordinates } from '~/pages/projectDetails/civildraw/widgets/ObjectDetails/ObjCoordinates';
import { isPermittingLocalMap } from '~/pages/projectDetails/pdfGeneration/permittingMapConstants';
import { useCivilDrawStore } from '../../civilDrawStoreContext';
import ImagePreview from './ImagePreview';
import ObjActions from './ObjActions';
import { ObjAttachments } from './ObjAttachments';
import ObjCreationData from './ObjCreationData';
import ObjDescription from './ObjDescription';
import ObjRadius from './ObjRadius';
import ObjStyles from './ObjStyles/ObjStyles';
import ObjTitle from './ObjTitle';

export default function ObjectDetails() {
  const store = useCivilDrawStore();
  const { currentObject, currentUnitSystem, currentMapId } = useSnapshot(store) as typeof store;
  const permittingPdfEmbed = isPermittingLocalMap(currentMapId);

  if (!currentObject || currentObject.type === 'comment') {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute right-0 top-0 z-10 m-4 flex max-h-[83.333333%] w-96 flex-col rounded bg-white text-sm text-grey-50 shadow-md shadow-grey-70',
        permittingPdfEmbed && 'h-full',
      )}
    >
      <div className="h-fit shrink-0 rounded-t bg-white px-6 pb-4 pt-6">
        {/* Type of object and edit/close buttons */}
        <ObjActions currentObject={currentObject} />
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-6">
        {/* Object Title and Icon */}
        <ObjTitle currentObject={currentObject} />

        {/* Creator and Object Geometry */}
        <ObjCreationData currentObject={currentObject} unitSystem={currentUnitSystem} />

        {/* Object Description */}
        {currentObject.type !== 'textV2' && currentObject.type !== 'stamp' && (
          <ObjDescription currentObject={currentObject} />
        )}

        <ImagePreview currentObject={currentObject} />

        <ObjRadius currentObject={currentObject} />

        {/* Object Attachments */}
        {currentObject.type !== 'image' && currentObject.type !== 'stamp' && <ObjAttachments />}

        {/* Object Styles */}
        <ObjStyles />

        {/* Object Coordinates */}
        <ObjCoordinates currentObject={currentObject} />
      </div>
    </div>
  );
}
